import { composeIO } from 'react-compose-io'
import { tabTransformacaoApiIO } from './TabTransformacaoApi.IO'
import TabTransformacaoApiView from './TabTransformacaoApi.View'

export const TabTransformacaoApi = composeIO(TabTransformacaoApiView, tabTransformacaoApiIO)
